/* eslint-disable react-hooks/exhaustive-deps */
'use client';

import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import Fieldset from '~/components/commonUi/Fieldset';
import { StandAdminUserVote } from '~/definitions/report';
import { getStore } from '~/mobx/AppStore';
import formatIsoLocalToDateTimeString from '~/utils/formatIsoLocalToDateTimeString';

type Props = {
    items: StandAdminUserVote[];
};

const StandVotesList = (props: Props) => {
    const { items } = props;
    if (!items || items.length === 0) {
        return null;
    }

    const classNamesTable = `table-md w-full text-gray-900 leading-[27px] mt-4 mb-4`;
    const classNamesHead = `bg-custom-gray-05 align-top`;
    const classNamesHeadCell = `text-left`;
    const classNamesHeadFirstCell = ` w-1/3`;
    const classNamesRow = ` border-b border-gray-300`;
    const classNamesRowCell = `text-left`;

    const renderCountingVotesRows = (adminId: string, results: StandAdminUserVote['results'] = []) => {
        if (!results || results.length === 0) {
            return null;
        }

        return results.map((vote, index) => {
            const classNamesRowBg = index % 2 === 0 ? ' bg-[#e3e3e3]' : '';
            return (
                <tr key={`vote-row-${adminId}-${index}`} className={classNamesRow + classNamesRowBg}>
                    <td className={classNamesRowCell}>{vote.user_id}</td>
                    <td className={classNamesRowCell}>
                        {formatIsoLocalToDateTimeString(vote.ts, 'YYYY-MM-DD HH:mm:ss')}
                    </td>
                </tr>
            );
        });
    };

    const renderStandAdminSections = () => {
        return items.map((item) => {
            const fullName = item?.name || '';
            const title = item.email ? `${fullName} (${item.email})` : fullName;
            const results = item.results || [];
            if (item.user_count < 1 || results.length === 0) {
                return null;
            }
            return (
                <div className="mb-[20px] last:mb-0" key={item.stand_admin_id}>
                    <Fieldset title={title}>
                        <table className={classNamesTable}>
                            <thead>
                                <tr className={classNamesHead}>
                                    <th className={classNamesHeadCell + classNamesHeadFirstCell}>Medlem</th>
                                    <th className={classNamesHeadCell}>Tidspunkt</th>
                                </tr>
                            </thead>
                            <tbody>{renderCountingVotesRows(item.stand_admin_id, results)}</tbody>
                        </table>
                    </Fieldset>
                </div>
            );
        });
    };

    return <div className="vote-adm-cand overflow-x-auto">{renderStandAdminSections()}</div>;
};

const StandVotesListWithStore = () => {
    const { reportStore } = getStore();
    const { isShowedUserVoteList } = reportStore;

    useEffect(() => {
        if (isShowedUserVoteList) {
            reportStore.getStandAdminUserVoteListByRegion();
        }
    }, [isShowedUserVoteList]);

    return <StandVotesList items={reportStore.standAdminUserVoteList || []} />;
};

export default observer(StandVotesListWithStore);
